const iconMap = {
	arrow: require('./lib/Arrow').default,
	'arrow-left': require('./lib/Arrow').default,
	'arrow-right': require('./lib/ArrowRight').default,
	asset: require('./lib/AssetDefault').default,
	'asset-activity': require('./lib/AssetActivity').default,
	'asset-audio': require('./lib/AssetAudio').default,
	'asset-article': require('./lib/AssetText').default,
	'asset-default': require('./lib/AssetDefault').default,
	'asset-diagram': require('./lib/AssetDiagram').default,
	'asset-fluidbook': require('./lib/AssetFluidbook').default,
	'asset-folder': require('./lib/AssetFolder').default,
	'asset-image': require('./lib/AssetImage').default,
	'asset-infographic': require('./lib/AssetInfographic').default,
	'asset-link': require('./lib/AssetLink').default,
	'asset-pdf': require('./lib/AssetPdf').default,
	'asset-podcast': require('./lib/AssetPodcast').default,
	'asset-presentation': require('./lib/AssetPresentation').default,
	'asset-quiz': require('./lib/AssetQuiz').default,
	'asset-spreadsheet': require('./lib/AssetSpreadsheet').default,
	'asset-text': require('./lib/AssetText').default,
	'asset-video': require('./lib/AssetVideo').default,
	'asset-webinar': require('./lib/AssetWebinar').default,
	bang: require('./lib/Bang').default,
	box: require('./lib/Box').default,
	calendar: require('./lib/Calendar').default,
	captions: require('./lib/Captions').default,
	chat: require('./lib/Chat').default,
	chevron: require('./lib/Chevron').default,
	cycle: require('./lib/Cycle').default,
	dislike: require('./lib/Dislike').default,
	disk: require('./lib/Disk').default,
	dot: require('./lib/Dot').default,
	download: require('./lib/Download').default,
	'drag-and-drop': require('./lib/DragAndDrop').default,
	edit: require('./lib/Edit').default,
	ellipsis: require('./lib/Ellipsis').default,
	external: require('./lib/External').default,
	'eye-closed': require('./lib/EyeClosed').default,
	'eye-open': require('./lib/EyeOpen').default,
	favourite: require('./lib/Favourite').default,
	flag: require('./lib/Flag').default,
	forbidden: require('./lib/Forbidden').default,
	fullscreen: require('./lib/Fullscreen').default,
	'fullscreen-exit': require('./lib/FullscreenExit').default,
	globe: require('./lib/Globe').default,
	hierarchy: require('./lib/Hierarchy').default,
	home: require('./lib/Home').default,
	info: require('./lib/Info').default,
	key: require('./lib/Key').default,
	like: require('./lib/Like').default,
	link: require('./lib/Link').default,
	lock: require('./lib/Lock').default,
	logout: require('./lib/Logout').default,
	megaphone: require('./lib/Megaphone').default,
	menu: require('./lib/Menu').default,
	minus: require('./lib/Minus').default,
	'move-vertical': require('./lib/MoveVertical').default,
	'nav-down': require('./lib/NavDown').default,
	'nav-left': require('./lib/NavLeft').default,
	'nav-right': require('./lib/NavRight').default,
	'nav-up': require('./lib/NavUp').default,
	nudge: require('./lib/Nudge').default,
	ok: require('./lib/Ok').default,
	pause: require('./lib/Pause').default,
	pin: require('./lib/Pin').default,
	play: require('./lib/Play').default,
	playlist: require('./lib/Playlist').default,
	'playlist-link': require('./lib/PlaylistLink').default,
	plus: require('./lib/Plus').default,
	redo: require('./lib/Redo').default,
	section: require('./lib/Section').default,
	search: require('./lib/Search').default,
	send: require('./lib/Send').default,
	settings: require('./lib/Settings').default,
	share: require('./lib/Share').default,
	'sidebar-close': require('./lib/SidebarClose').default,
	'sidebar-open': require('./lib/SidebarOpen').default,
	skip: require('./lib/Skip').default,
	spanner: require('./lib/Spanner').default,
	sparkles: require('./lib/Sparkles').default,
	spinnerdot: require('./lib/Spinnerdot').default,
	star: require('./lib/Star').default,
	tag: require('./lib/Tag').default,
	team: require('./lib/Team').default,
	time: require('./lib/Time').default,
	tools: require('./lib/Tools').default,
	topic: require('./lib/Topic').default,
	trash: require('./lib/Trash').default,
	trending: require('./lib/Trending').default,
	undo: require('./lib/Undo').default,
	unpin: require('./lib/Unpin').default,
	upload: require('./lib/Upload').default,
	user: require('./lib/User').default,
	warning: require('./lib/Warning').default,
	x: require('./lib/X').default,
};

export default iconMap;
